module.exports = __webpack_public_path__ + "3ab919d3fc7be8736c36a5d7012e6f6c.svg";